import { xhrGet } from './xhr-apis'

// 所有学制的年级信息数组
export const grades = [
  {
    name: '小学',
    value: 1,
    children: [
      {
        name: '一年级',
        value: '1'
      },
      {
        name: '二年级',
        value: '2'
      },
      {
        name: '三年级',
        value: '3'
      },
      {
        name: '四年级',
        value: '4'
      },
      {
        name: '五年级',
        value: '5'
      },
      {
        name: '六年级',
        value: '6'
      }
    ]
  },
  {
    name: '初中',
    value: 2,
    children: [
      {
        name: '初一年级',
        value: '7'
      },
      {
        name: '初二年级',
        value: '8'
      },
      {
        name: '初三年级',
        value: '9'
      }
    ]
  },
  {
    name: '高中',
    value: 3,
    children: [
      {
        name: '高一年级',
        value: '10'
      },
      {
        name: '高二年级',
        value: '11'
      },
      {
        name: '高三年级',
        value: '12'
      }
    ]
  },
  {
    name: '九年一贯',
    value: 4,
    children: [
      {
        name: '一年级',
        value: '1'
      },
      {
        name: '二年级',
        value: '2'
      },
      {
        name: '三年级',
        value: '3'
      },
      {
        name: '四年级',
        value: '4'
      },
      {
        name: '五年级',
        value: '5'
      },
      {
        name: '六年级',
        value: '6'
      },
      {
        name: '七年级',
        value: '7'
      },
      {
        name: '八年级',
        value: '8'
      },
      {
        name: '九年级',
        value: '9'
      }
    ]
  }
]
// 判断数据是否超出缓存时间（十分钟）
const isEffectiveDaTa = function(termNow, timeout = 60 * 10 * 1000) {
  if (termNow && termNow.time) {
    if (Date.now() - termNow.time < timeout) {
      return true
    }
  }
  return false
}

/* 年级查询接口 START******************************************************************************/

// 根据用户的学制查询所有年级
export const getGradesBySchoolStage = function(schoolStage) {
  const grade = grades.filter(g => g.value === schoolStage)
  return grade.length > 0 ? grade[0].children : []
}

// 当前教师任课年级
export const getGradesByTeacher = function() {
  const local = {}
  return () => {
    return new Promise((resolve, reject) => {
      if (isEffectiveDaTa(local, 10 * 1000)) {
        resolve(local.data)
      } else {
        xhrGet('/acc/teacher/grade')
          .then(res => {
            if (
              res.code === 'SUCCESS' &&
              Array.isArray(res.data) &&
              res.data.length > 0
            ) {
              local.time = Date.now()
              local.data = res.data
              resolve(res.data)
            } else {
              local.time = null
              local.data = null
              resolve(null)
            }
          })
          .catch(e => {
            console.log(e)
            reject(e)
          })
      }
    })
  }
}

// 查询当前教师有权限的年级
export const getAllGradesByTeacher = function() {
  const local = {}
  return moduleId => {
    return new Promise((resolve, reject) => {
      if (isEffectiveDaTa(local, 10 * 1000)) {
        resolve(local.data)
      } else {
        xhrGet('/acc/teacher/grades', {
          moduleId
        })
          .then(res => {
            if (
              res.code === 'SUCCESS' &&
              Array.isArray(res.data) &&
              res.data.length > 0
            ) {
              local.time = Date.now()
              local.data = res.data
              resolve(res.data)
            } else {
              local.time = null
              local.data = null
              resolve(null)
            }
          })
          .catch(e => {
            console.log(e)
            reject(e)
          })
      }
    })
  }
}

// 当前教师担任班主任年级
export const getGradesByClassTeacher = function() {
  const local = {}
  return () => {
    return new Promise((resolve, reject) => {
      if (isEffectiveDaTa(local, 10 * 1000)) {
        resolve(local.data)
      } else {
        xhrGet('/acc/teacher/grades/class-teacher')
          .then(res => {
            if (
              res.code === 'SUCCESS' &&
              Array.isArray(res.data) &&
              res.data.length > 0
            ) {
              local.time = Date.now()
              local.data = res.data
              resolve(res.data)
            } else {
              local.time = null
              local.data = null
              resolve(null)
            }
          })
          .catch(e => {
            console.log(e)
            reject(e)
          })
      }
    })
  }
}

/* 年级查询接口 END******************************************************************************/

/* 班级查询接口 START******************************************************************************/

// 获取当前教师指定年级的所有任课班级
export const getClassByTeacherGrade = function() {
  const terms = {}
  return grade => {
    return new Promise((resolve, reject) => {
      if (isEffectiveDaTa(terms[grade])) {
        resolve(terms[grade].data)
      } else {
        terms[grade] = {
          data: null,
          time: null
        }
        xhrGet('/acc/teacher/classes', {
          grade
        })
          .then(res => {
            if (
              res.code === 'SUCCESS' &&
              Array.isArray(res.data) &&
              res.data.length > 0
            ) {
              terms[grade].time = Date.now()
              terms[grade].data = res.data
              resolve(res.data)
            } else {
              terms[grade].time = null
              terms[grade].data = null
              resolve(null)
            }
          })
          .catch(e => {
            terms[grade].time = null
            terms[grade].data = null
            reject(e)
          })
      }
    })
  }
}

// 获取对应年级下的全部班级或者任课班级
export const getClassesByTeacher = function() {
  const terms = {}
  return (grade, moduleId) => {
    return new Promise((resolve, reject) => {
      if (isEffectiveDaTa(terms[grade])) {
        resolve(terms[grade].data)
      } else {
        terms[grade] = {
          data: null,
          time: null
        }
        xhrGet('/acc/teacher/classes/operable', {
          grade,
          moduleId
        })
          .then(res => {
            if (
              res.code === 'SUCCESS' &&
              Array.isArray(res.data) &&
              res.data.length > 0
            ) {
              terms[grade].time = Date.now()
              terms[grade].data = res.data
              resolve(res.data)
            } else {
              terms[grade].time = null
              terms[grade].data = null
              resolve(null)
            }
          })
          .catch(e => {
            terms[grade].time = null
            terms[grade].data = null
            reject(e)
          })
      }
    })
  }
}

// 获取当前老师担任班主任的班级
export const getClassesByHeadmaster = function() {
  const local = {}
  return grade => {
    return new Promise((resolve, reject) => {
      if (isEffectiveDaTa(local[grade])) {
        resolve(local[grade].data)
      } else {
        local[grade] = {
          data: null,
          time: null
        }
        xhrGet('/acc/teacher/classes/class-teacher', {
          grade
        })
          .then(res => {
            if (
              res.code === 'SUCCESS' &&
              Array.isArray(res.data) &&
              res.data.length > 0
            ) {
              local[grade].time = Date.now()
              local[grade].data = res.data
              resolve(res.data)
            } else {
              local[grade].time = null
              local[grade].data = null
              resolve(null)
            }
          })
          .catch(e => {
            local[grade].time = null
            local[grade].data = null
            console.log(e)
            reject(e)
          })
      }
    })
  }
}

/* 班级查询接口 END******************************************************************************/

/* 学期查询接口 START******************************************************************************/

// 获取学生的所有历史学期
export const getSchoolsTermsStudent = function() {
  const local = {
    time: null,
    data: null
  }
  return () => {
    return new Promise((resolve, reject) => {
      if (isEffectiveDaTa(local, 10 * 1000)) {
        resolve(local.data)
      } else {
        xhrGet('/acc/schools/terms/student')
          .then(res => {
            if (
              res.code === 'SUCCESS' &&
              Array.isArray(res.data) &&
              res.data.length > 0
            ) {
              local.time = Date.now()
              local.data = res.data
              resolve(res.data)
            } else {
              local.time = null
              local.data = null
              resolve(null)
            }
          })
          .catch(e => {
            local.time = null
            local.data = null
            reject(e)
          })
      }
    })
  }
}

// 根据年级查询历史学期
export const getTermsByGrade = function() {
  const local = {}
  return grade => {
    return new Promise((resolve, reject) => {
      if (isEffectiveDaTa(local[grade], 10 * 1000)) {
        resolve(local[grade].data)
      } else {
        local[grade] = {}
        xhrGet(`/acc/schools/grade/${grade}/terms`, {
          grade
        })
          .then(res => {
            if (
              res.code === 'SUCCESS' &&
              Array.isArray(res.data) &&
              res.data.length > 0
            ) {
              local[grade].time = Date.now()
              local[grade].data = res.data
              resolve(res.data)
            } else {
              local[grade].time = null
              local[grade].data = null
              resolve(null)
            }
          })
          .catch(e => {
            local[grade].time = null
            local[grade].data = null
            reject(e)
          })
      }
    })
  }
}

// 获取当前学年所有学期
export const getTermNowAll = function() {
  const terms = {
    time: null,
    data: null
  }
  return () => {
    return new Promise((resolve, reject) => {
      if (isEffectiveDaTa(terms, 10 * 1000)) {
        resolve(terms.data)
      } else {
        xhrGet('/acc/schools/school-year/terms')
          .then(res => {
            if (
              res.code === 'SUCCESS' &&
              Array.isArray(res.data) &&
              res.data.length > 0
            ) {
              terms.time = Date.now()
              terms.data = res.data
              resolve(res.data)
            } else {
              terms.time = null
              terms.data = null
              resolve(null)
            }
          })
          .catch(e => {
            terms.time = null
            terms.data = null
            reject(e)
          })
      }
    })
  }
}
// 获取当前学年当前学期
export const getTermNow = function() {
  const terms = getTermNowAll()
  return () => {
    return new Promise((resolve, reject) => {
      terms()
        .then(data => {
          resolve(termFilter(data))
        })
        .catch(e => {
          reject(e)
        })
    })
  }
}
// 从学期数组中过滤出当前学期
const termFilter = function(terms) {
  if (Array.isArray(terms) && terms.length > 0) {
    const f = terms.filter(i => i.right)
    if (f.length > 0) {
      return f[0]
    }
  }
  return null
}

/* 学期查询接口 END******************************************************************************/

/* 学科查询接口 START******************************************************************************/

// 根据权限获取任教学科或者班级全部学科
export const getSubjectsByTeacherOrClass = function() {
  const local = {}
  return (classId, moduleId) => {
    return new Promise((resolve, reject) => {
      if (isEffectiveDaTa(local[classId], 10 * 1000)) {
        resolve(local[classId].data)
      } else {
        local[classId] = {}
        xhrGet(`/acc/classes/${classId}/subjects/operable`, {
          moduleId
        })
          .then(res => {
            if (
              res.code === 'SUCCESS' &&
              Array.isArray(res.data) &&
              res.data.length > 0
            ) {
              local[classId].time = Date.now()
              local[classId].data = res.data
              resolve(res.data)
            } else {
              local[classId].time = null
              local[classId].data = null
              resolve(null)
            }
          })
          .catch(e => {
            local[classId].time = null
            local[classId].data = null
            reject(e)
          })
      }
    })
  }
}

/* 学科查询接口 END******************************************************************************/

/* 学年查询接口 START******************************************************************************/

// 根据选择的年级进行联动，实际有几个学年显示几个即可
export const getSchoolYearByGrade = function() {
  const local = {}
  return grade => {
    return new Promise((resolve, reject) => {
      if (isEffectiveDaTa(local[grade], 10 * 1000)) {
        resolve(local[grade].data)
      } else {
        local[grade] = {}
        xhrGet('/acc/students/school-years', {
          grade
        })
          .then(res => {
            if (
              res.code === 'SUCCESS' &&
              Array.isArray(res.data) &&
              res.data.length > 0
            ) {
              local[grade].time = Date.now()
              local[grade].data = res.data
              resolve(res.data)
            } else {
              local[grade].time = null
              local[grade].data = null
              resolve(null)
            }
          })
          .catch(e => {
            local[grade].time = null
            local[grade].data = null
            reject(e)
          })
      }
    })
  }
}

/* 学年查询接口 END******************************************************************************/



// WEBPACK FOOTER //
// ./src/util/paramsUtils.js